export const orgaExamples: Array<{imgsUrl: {desktop: string, mobile: string}, name: string, color: string}> = [
  {
    imgsUrl: {
      desktop: 'home-orga/bobital-desktop.png',
      mobile: 'home-orga/bobital-mobile.png',
    },
    name: 'Festival Bobital',
    color: '#2a486a',
  },
  {
    imgsUrl: {
      desktop: 'home-orga/poupet-desktop.png',
      mobile: 'home-orga/poupet-mobile.png',
    },
    name: 'Festival de Poupet',
    color: '#66304c',
  },
];
